$(document).ready(function() {
    const exportDatatableModal = $("#export-datatable-modal");

    $(".js-export-columns-row").on("click", ".js-column-checkbox", function() {
        let th = $(`th[aria-label="${$(this).data("label")}"]`);
        if ($(this).is(":checked")) {
            if (th.hasClass("noExport")) {
                th.removeClass("noExport");
            }
        } else {
            if (!th.hasClass("noExport")) {
                th.addClass("noExport");
            }
        }
    });
    $(".js-confirm-export").on("click", function() {
        fnAction($(this).data("action"));
    });

    exportDatatableModal.on("hidden.bs.modal", function() {
        $(".js-export-columns-row").html("");
    });

    function fnAction(action) {
        switch (action) {
            case "excel":
                $(".buttons-excel").trigger("click");
                break;
            case "pdf":
                $(".buttons-pdf").trigger("click");
                break;
            case "copy":
                $(".buttons-copy").trigger("click");
                break;
        }
        exportDatatableModal.modal("hide");
    }
});
